<div class="page-content">
    <section class="byob-builder py-5">
        <div class="container">
            <div class="text-center mb-3">
                <h2 class="title w-100 fs-3 mb-1 text-black tamil">
                    Build Your Own Gift Box
                </h2>
                <p class="dz-title fs-6 mb-0 fw-bold text-center">
                    Select a gift box to begin.
                </p>
            </div>

            <div class="row g-2 justify-content-center">
                <div class="card-container col-6 col-xl-6 col-lg-6 col-md-6 col-sm-6" *ngFor="let box of boxes">
                    <div class="shop-card" [class.selected]="box.selected">
                        <div class="row">
                            <div class="col-12 col-md-6 col-lg-6 col-xl-6">
                                <div class="dz-media">
                                    <img [src]="box.thumbnail_image_full_url" [alt]="box.name" width="400" height="400">
                                </div>
                            </div>
                            <div class="col-12 col-md-6 col-lg-6 col-xl-6">
                                <div class="dz-info mt-2">
                                    <div class="dz-content p-0">
                                        <h5 class="title w-100 fs-4 mb-2 text-black">
                                            {{ box.name }}
                                        </h5>
                                    </div>
                                    <div class="meta-content p-0 mb-2">
                                        <span class="price lh-1">
                                            <ng-container
                                                *ngIf="box.special_price && +box.special_price>0; else boxMrp">
                                                ₹{{box.special_price}}
                                                <del *ngIf="box.special_price!=box.mrp_price">
                                                    ₹{{box.mrp_price}}
                                                </del>
                                            </ng-container>
                                            <ng-template #boxMrp>
                                                ₹{{box.mrp_price}}
                                            </ng-template>
                                        </span>
                                    </div>
                                    <div class="rounded p-2">
                                        <p class="mb-1 text-danger fw-semibold small">
                                            ✔&nbsp;&nbsp;Choose Minimum 3 Books
                                        </p>
                                        <p class="mb-1 text-danger fw-semibold small">
                                            ✔&nbsp;&nbsp;Choose Minimum 3 Bookmarks
                                        </p>
                                        <p class="mb-1 text-danger fw-semibold small">
                                            ✔&nbsp;&nbsp;Choose Minimum 1 Badge
                                        </p>
                                        <p class="mb-1 text-danger fw-semibold small">
                                            ✔&nbsp;&nbsp;Choose Minimum 1 Crochet
                                        </p>
                                        <p class="mb-0 text-danger fw-semibold small">
                                            ✔&nbsp;&nbsp;Choose Minimum 3 Stationery Items
                                        </p>
                                    </div>
                                    <div class="add-cart-button p-0 mb-0">
                                        <button type="button" class="btn"
                                            [ngClass]="box.selected ? 'btn-danger' : 'btn-white btn-border'"
                                            (click)="selectBox(box)">
                                            <i class="fa me-1" [ngClass]="box.selected ? 'fa-check' : 'fa-plus'"></i>
                                            {{ box.selected ? 'Selected' : 'Choose This Box' }}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="product-tag" *ngIf="box.selected">
                            <span class="badge bg-success">
                                Selected
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <div *ngIf="selectedBox">
                <div class="builder-header mb-1">
                    <div class="">
                        <h2 class="title w-100 fs-5 mb-1 text-black tamil">
                            Step 2 - Select Books
                        </h2>
                        <p class="dz-title fs-6 mb-1 fw-bold">
                            Choose at least <strong>3 Books</strong> to continue.
                        </p>
                    </div>
                </div>
                <div class="alert alert-warning mb-1 p-2" *ngIf="selectedBooks.length < minBooks">
                    <strong>
                        {{ minBooks-selectedBooks.length }}
                    </strong>
                    more book(s) required to continue.
                </div>
                <div class="alert alert-success mb-1 p-2" *ngIf="selectedBooks.length >= minBooks">
                    <i class="fa fa-check-circle me-2"></i>
                    Great! You have selected the required books.
                </div>
                <div class="row g-xl-4 g-3">
                    <div class="card-container col-xl-3 col-lg-4 col-md-4 col-sm-6 col-6" *ngFor="let book of books">
                        <div class="shop-card">
                            <div class="dz-media">
                                <img [src]="book.thumbnail_image_full_url" [alt]="book.name" width="400" height="400">
                            </div>
                            <div class="dz-info mt-2">
                                <div class="dz-content p-0">
                                    <h5 class="title w-100 fs-5 mb-2 text-black">
                                        {{ book.name }}
                                    </h5>
                                </div>
                                <div class="meta-content p-0 mb-2">
                                    <span class="price lh-1">
                                        <ng-container *ngIf="book.special_price && +book.special_price>0; else bookMrp">
                                            ₹{{book.special_price}}
                                            <del *ngIf="book.special_price!=book.mrp_price">
                                                ₹{{book.mrp_price}}
                                            </del>
                                        </ng-container>
                                        <ng-template #bookMrp>
                                            ₹{{book.mrp_price}}
                                        </ng-template>
                                    </span>
                                </div>
                                <div class="d-flex gap-2 mb-2 align-items-center justify-content-between">
                                    <div class="add-cart-button p-0 mb-0">
                                        <button class="btn"
                                            [ngClass]="book.selected ? 'btn-danger' : 'btn-white btn-border'"
                                            (click)="toggleBook(book)">
                                            <i class="fa me-1" [ngClass]="book.selected ? 'fa-check' : 'fa-plus'"></i>
                                            {{ book.selected ? 'Selected' : 'Select Book' }}
                                        </button>
                                    </div>
                                    <a [routerLink]="['/products', slugify(book.name)]" target="_top">Book Description<i class="ms-1 fa-solid fa-arrow-up-right-from-square"></i></a>
                                </div>
                            </div>
                            <div class="product-tag" *ngIf="book.special_price">
                                <span class="badge">
                                    {{
                                    ((book.mrp_price-book.special_price)
                                    /book.mrp_price*100)
                                    | number:'1.0-0'
                                    }}% OFF
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div *ngIf="canSelectBookmarks()">
                <div class="builder-header mb-1">
                    <div class="">
                        <h2 class="title w-100 fs-5 mb-1 text-black tamil">
                            Step 3 - Select Bookmarks
                        </h2>
                        <p class="dz-title fs-6 mb-1 fw-bold">
                            Choose at least <strong>3 Bookmarks</strong> to continue.
                        </p>
                    </div>
                </div>
                <div class="alert alert-warning mb-1 p-2" *ngIf="selectedBookmarks.length < minBookmarks">
                    Please select <strong> {{ minBookmarks-selectedBookmarks.length }} </strong> more bookmark(s).
                </div>
                <div class="alert alert-success mb-1 p-2" *ngIf="selectedBookmarks.length >= minBookmarks">
                    <i class="fa fa-check-circle me-2"></i>
                    Great! Bookmark selection completed.
                </div>
                <div class="row g-xl-4 g-3">
                    <div class="card-container col-xl-3 col-lg-4 col-md-4 col-sm-6 col-6"
                        *ngFor="let bookmark of bookmarks">
                        <div class="shop-card">
                            <div class="dz-media">
                                <img [src]="bookmark.thumbnail_image_full_url" [alt]="bookmark.name" width="400"
                                    height="400">
                            </div>
                            <div class="dz-info mt-2">
                                <div class="dz-content p-0">
                                    <h5 class="title w-100 fs-5 mb-2 text-black">
                                        {{ bookmark.name }}
                                    </h5>
                                </div>
                                <div class="meta-content p-0 mb-2">
                                    <span class="price lh-1">
                                        <ng-container
                                            *ngIf="bookmark.special_price && +bookmark.special_price>0; else bookmarkMrp">
                                            ₹{{bookmark.special_price}}
                                            <del *ngIf="bookmark.special_price!=bookmark.mrp_price">
                                                ₹{{bookmark.mrp_price}}
                                            </del>
                                        </ng-container>
                                        <ng-template #bookmarkMrp>
                                            ₹{{bookmark.mrp_price}}
                                        </ng-template>
                                    </span>
                                </div>
                                <div class="add-cart-button p-0 mb-0">
                                    <button class="btn"
                                        [ngClass]="bookmark.selected ? 'btn-danger' : 'btn-white btn-border'"
                                        (click)="toggleBookmark(bookmark)">
                                        <i class="fa me-1" [ngClass]="bookmark.selected ? 'fa-check' : 'fa-plus'"></i>
                                        {{ bookmark.selected ? 'Selected' : 'Select Bookmark' }}
                                    </button>
                                </div>
                            </div>
                            <div class="product-tag" *ngIf="bookmark.special_price">
                                <span class="badge">
                                    {{
                                    ((bookmark.mrp_price-bookmark.special_price)
                                    /bookmark.mrp_price*100)
                                    | number:'1.0-0'
                                    }}% OFF
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div *ngIf="canSelectBadges()">
                <div class="builder-header mb-1">
                    <div class="">
                        <h2 class="title w-100 fs-5 mb-1 text-black tamil">
                            Step 4 - Select Badge
                        </h2>
                        <p class="dz-title fs-6 mb-1 fw-bold">
                            Choose at least <strong>1 Badge</strong> to continue.
                        </p>
                    </div>
                </div>
                <div class="alert alert-warning mb-1 p-2" *ngIf="selectedBadges.length < minBadges">
                    Please select at least <strong>1 Badge</strong>.
                </div>
                <div class="alert alert-success mb-1 p-2" *ngIf="selectedBadges.length >= minBadges">
                    <i class="fa fa-check-circle me-2"></i>
                    Badge selection completed.
                </div>
                <div class="row g-xl-4 g-3">
                    <div class="card-container col-xl-3 col-lg-4 col-md-4 col-sm-6 col-6" *ngFor="let badge of badges">
                        <div class="shop-card">
                            <div class="dz-media">
                                <img [src]="badge.thumbnail_image_full_url" [alt]="badge.name" width="400" height="400">
                            </div>
                            <div class="dz-info mt-2">
                                <div class="dz-content p-0">
                                    <h5 class="title w-100 fs-5 mb-2 text-black">
                                        {{ badge.name }}
                                    </h5>
                                </div>
                                <div class="meta-content p-0 mb-2">
                                    <span class="price lh-1">
                                        <ng-container
                                            *ngIf="badge.special_price && +badge.special_price > 0; else badgeMrp">
                                            ₹{{badge.special_price}}
                                            <del *ngIf="badge.special_price != badge.mrp_price">
                                                ₹{{badge.mrp_price}}
                                            </del>
                                        </ng-container>
                                        <ng-template #badgeMrp>
                                            ₹{{badge.mrp_price}}
                                        </ng-template>
                                    </span>
                                </div>
                                <div class="add-cart-button p-0 mb-0">
                                    <button class="btn"
                                        [ngClass]="badge.selected ? 'btn-danger' : 'btn-white btn-border'"
                                        (click)="toggleBadge(badge)">
                                        <i class="fa me-1" [ngClass]="badge.selected ? 'fa-check' : 'fa-plus'"></i>
                                        {{ badge.selected ? 'Selected' : 'Select Badge' }}
                                    </button>
                                </div>
                            </div>
                            <div class="product-tag" *ngIf="badge.special_price">
                                <span class="badge">
                                    {{
                                    ((badge.mrp_price-badge.special_price)
                                    /badge.mrp_price*100)
                                    | number:'1.0-0'
                                    }}% OFF
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div *ngIf="canSelectCrochets()">
                <div class="builder-header mb-1">
                    <div class="">
                        <h2 class="title w-100 fs-5 mb-1 text-black tamil">
                            Step 5 - Select Crochet
                        </h2>
                        <p class="dz-title fs-6 mb-1 fw-bold">
                            Choose at least <strong>1 Crochet</strong> to continue.
                        </p>
                    </div>
                </div>
                <div class="alert alert-warning mb-1 p-2" *ngIf="selectedCrochets.length < minCrochets">
                    Please select at least <strong>1 Crochet</strong>.
                </div>
                <div class="alert alert-success mb-1 p-2" *ngIf="selectedCrochets.length >= minCrochets">
                    <i class="fa fa-check-circle me-2"></i>
                    Crochet selection completed.
                </div>
                <div class="row g-xl-4 g-3">
                    <div class="card-container col-xl-3 col-lg-4 col-md-4 col-sm-6 col-6"
                        *ngFor="let crochet of crochets">
                        <div class="shop-card">
                            <div class="dz-media">
                                <img [src]="crochet.thumbnail_image_full_url" [alt]="crochet.name" width="400"
                                    height="400">
                            </div>
                            <div class="dz-info mt-2">
                                <div class="dz-content p-0">
                                    <h5 class="title w-100 fs-5 mb-2 text-black">
                                        {{ crochet.name }}
                                    </h5>
                                </div>
                                <div class="meta-content p-0 mb-2">
                                    <span class="price lh-1">
                                        <ng-container
                                            *ngIf="crochet.special_price && +crochet.special_price > 0; else crochetMrp">
                                            ₹{{crochet.special_price}}
                                            <del *ngIf="crochet.special_price != crochet.mrp_price">
                                                ₹{{crochet.mrp_price}}
                                            </del>
                                        </ng-container>
                                        <ng-template #crochetMrp>
                                            ₹{{crochet.mrp_price}}
                                        </ng-template>
                                    </span>
                                </div>
                                <div class="add-cart-button p-0 mb-0">
                                    <button class="btn"
                                        [ngClass]="crochet.selected ? 'btn-danger' : 'btn-white btn-border'"
                                        (click)="toggleCrochet(crochet)">
                                        <i class="fa me-1" [ngClass]="crochet.selected ? 'fa-check' : 'fa-plus'"></i>
                                        {{ crochet.selected ? 'Selected' : 'Select Crochet' }}
                                    </button>
                                </div>
                            </div>
                            <div class="product-tag" *ngIf="crochet.special_price">
                                <span class="badge">
                                    {{
                                    ((crochet.mrp_price-crochet.special_price)
                                    /crochet.mrp_price*100)
                                    | number:'1.0-0'
                                    }}% OFF
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div *ngIf="canSelectStationery()">
                <div class="builder-header mb-1">
                    <div class="">
                        <h2 class="title w-100 fs-5 mb-1 text-black tamil">
                            Step 6 - Select Stationery
                        </h2>
                        <p class="dz-title fs-6 mb-1 fw-bold">
                            Choose at least <strong>3 Stationery Items</strong> to continue.
                        </p>
                    </div>
                </div>
                <div class="alert alert-warning mb-1 p-2" *ngIf="selectedStationery.length < minStationery">
                    Please select <strong> {{ minStationery-selectedStationery.length }} </strong> more stationery
                    item(s).
                </div>
                <div class="alert alert-success mb-1 p-2" *ngIf="selectedStationery.length >= minStationery">
                    <i class="fa fa-check-circle me-2"></i>
                    Stationery selection completed.
                </div>
                <div class="row g-xl-4 g-3">
                    <div class="card-container col-xl-3 col-lg-4 col-md-4 col-sm-6 col-6"
                        *ngFor="let item of stationery">
                        <div class="shop-card">
                            <div class="dz-media">
                                <img [src]="item.thumbnail_image_full_url" [alt]="item.name">
                            </div>
                            <div class="dz-info mt-2">
                                <div class="dz-content p-0">
                                    <h5 class="title w-100 fs-5 mb-2 text-black">
                                        {{ item.name }}
                                    </h5>
                                </div>
                                <div class="meta-content p-0 mb-2">
                                    <span class="price">
                                        <ng-container
                                            *ngIf="item.special_price && +item.special_price>0; else stationeryMrp">
                                            ₹{{item.special_price}}
                                            <del *ngIf="item.special_price!=item.mrp_price">
                                                ₹{{item.mrp_price}}
                                            </del>
                                        </ng-container>
                                        <ng-template #stationeryMrp>
                                            ₹{{item.mrp_price}}
                                        </ng-template>
                                    </span>
                                </div>
                                <div class="add-cart-button p-0 mb-0">
                                    <button class="btn"
                                        [ngClass]="item.selected ? 'btn-danger' : 'btn-white btn-border'"
                                        (click)="toggleStationery(item)">
                                        <i class="fa me-1" [ngClass]="item.selected ? 'fa-check' : 'fa-plus'"></i>
                                        {{ item.selected ? 'Added' : 'Add To Bundle' }}
                                    </button>
                                </div>
                            </div>
                            <div class="product-tag" *ngIf="item.selected">
                                <span class="badge bg-success">
                                    Added
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="bundle-summary">
                <div class="bundle-progress">
                    <div class="bundle-progress-top">
                        <span>
                            {{
                            (selectedBox ? 1 : 0)
                            + selectedBooks.length
                            + selectedBookmarks.length
                            + selectedBadges.length
                            + selectedCrochets.length
                            + selectedStationery.length
                            }}
                            Product(s)
                        </span>
                        <span>
                            ₹{{totalPrice | number:'1.2-2'}}
                        </span>
                    </div>
                </div>
                <div class="bundle-products mb-1">
                    <div class="bundle-item" *ngIf="selectedBox">
                        <img [src]="selectedBox.thumbnail_image_full_url">
                        <div>
                            <h6>{{selectedBox.name}}</h6>
                            <small>
                                ₹{{selectedBox.special_price || selectedBox.mrp_price}}
                            </small>
                        </div>
                        <button class="remove-btn" (click)="removeSelectedBox()">
                            <i class="fa-solid fa-trash"></i>
                        </button>
                    </div>
                    <div class="bundle-item" *ngFor="let book of selectedBooks">
                        <img [src]="book.thumbnail_image_full_url">
                        <div>
                            <h6>{{book.name}}</h6>
                            <small>
                                ₹{{book.special_price || book.mrp_price}}
                            </small>
                        </div>
                        <button class="remove-btn" (click)="removeBook(book)">
                            <i class="fa-solid fa-trash"></i>
                        </button>
                    </div>
                    <div class="bundle-item" *ngFor="let bookmark of selectedBookmarks">
                        <img [src]="bookmark.thumbnail_image_full_url">
                        <div>
                            <h6>{{bookmark.name}}</h6>
                            <small>
                                ₹{{bookmark.special_price || bookmark.mrp_price}}
                            </small>
                        </div>
                        <button class="remove-btn" (click)="removeBookmark(bookmark)">
                            <i class="fa-solid fa-trash"></i>
                        </button>
                    </div>
                    <div class="bundle-item" *ngFor="let badge of selectedBadges">
                        <img [src]="badge.thumbnail_image_full_url">
                        <div>
                            <h6>{{badge.name}}</h6>
                            <small>
                                ₹{{badge.special_price || badge.mrp_price}}
                            </small>
                        </div>
                        <button class="remove-btn" (click)="removeBadge(badge)">
                            <i class="fa-solid fa-trash"></i>
                        </button>
                    </div>
                    <div class="bundle-item" *ngFor="let crochet of selectedCrochets">
                        <img [src]="crochet.thumbnail_image_full_url">
                        <div>
                            <h6>{{crochet.name}}</h6>
                            <small>
                                ₹{{crochet.special_price || crochet.mrp_price}}
                            </small>
                        </div>
                        <button class="remove-btn" (click)="removeCrochet(crochet)">
                            <i class="fa-solid fa-trash"></i>
                        </button>
                    </div>
                    <div class="bundle-item" *ngFor="let item of selectedStationery">
                        <img [src]="item.thumbnail_image_full_url">
                        <div>
                            <h6>{{item.name}}</h6>
                            <small>
                                ₹{{item.special_price || item.mrp_price}}
                            </small>
                        </div>
                        <button class="remove-btn" (click)="removeStationery(item)">
                            <i class="fa-solid fa-trash"></i>
                        </button>
                    </div>
                </div>
                <div class="bundle-footer">
                    <div class="bundle-total">
                        ₹{{totalPrice | number:'1.2-2'}}
                    </div>
                    <button class="btn btn-primary" [disabled]="!canCheckout()" (click)="addToCart()">
                        <i class="fa fa-shopping-cart me-2"></i>
                        Add To Cart
                    </button>
                </div>
            </div>
        </div>
    </section>